var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08888 14.6223L3.54443 15.3112H2.55554L3.47776 14.1445L4.08888 14.6223Z",
    fill: "#24293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 14.6223L12.1444 15.3112H13.1333L12.2111 14.1445L11.6 14.6223Z",
    fill: "#24293D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 14.6223L17.2444 15.3112H18.2333L17.3111 14.1445L16.7 14.6223Z",
    fill: "#24293D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 15.2556L2.98889 14.7779L7.84445 8.62231L12.5556 14.5779L11.9444 15.0556L7.84445 9.87787L3.6 15.2556Z",
    fill: "#24293D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3666 12.5778L12.6666 13.4666L12.1666 12.8444L12.7666 12.0889L13.3666 12.5778Z",
    fill: "#24293D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7889 14.7223L14.2334 11.489L12.9556 13.1001L12.3445 12.6223L14.2334 10.2334L17.4 14.2445L16.7889 14.7223Z",
    fill: "#24293D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5889 7.11101H7.78894V6.33324H12.2223L11.5889 5.25546L12.2223 4.17768H8.73338V3.3999H13.5889L12.4889 5.25546L13.5889 7.11101Z",
    fill: "#24293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1778 3.1333H7.40002V9.61108H8.1778V3.1333Z",
    fill: "#24293D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.28855224f59edca9c8d3e136de05238b.svg";
export { ForwardRef as ReactComponent };